module.exports = __webpack_public_path__ + "0e6999f994cb04982ff5b23a3b4120a7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/download.png
// module id = 2856
// module chunks = 0